<button
  type="button"
  class="button--sm button-block"
  (click)="updateItemAsync()"
  [class.button-primary]="!tool.addedToRA"
  [class.button-remove]="tool.addedToRA"
  [disabled]="!toolService.canAddToRA(tool)">
  <span
    *ngIf="!tool.addedToRA"
    class="flex middle center">
    <mat-icon svgIcon="service"></mat-icon>
    <span class="button__label">{{ "button.servicerequest" | translate }}</span></span
  >
  <span
    *ngIf="tool.addedToRA"
    class="flex middle center">
    <mat-icon svgIcon="service"></mat-icon>
    <span class="button__label">{{ "button.removerequest" | translate }}</span>
  </span>
</button>
